export default __webpack_public_path__ + "static/media/joshua.0ed7b76a.jpeg";